export default "__VITE_ASSET__5LnVXInq__"